// Campus photo for /colleges/mississippi-state-university: CC BY 4.0, by Traicovn, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AOld_Main_Academic_Center_-_Mississippi_State_University.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/mississippi-state-university/; credited under the photo.
const photo = {
    "slug": "mississippi-state-university",
    "alt": "The Old Main Academic Center, a red brick building with a columned entrance, on the Mississippi State University campus in Starkville",
    "src": "/colleges/mississippi-state-university/campus-1600.webp",
    "srcSmall": "/colleges/mississippi-state-university/campus-800.webp",
    "srcMid": "/colleges/mississippi-state-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/mississippi-state-university/og.jpg",
    "title": "Old Main Academic Center - Mississippi State University",
    "author": "Traicovn",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AOld_Main_Academic_Center_-_Mississippi_State_University.jpg",
    "read": "2026-10-01"
};

export default photo;
